<template>
  <div>
    <div class="item">
      <div class="ui icon input">
        <input
          type="text"
          :placeholder="$t('SEARCH')"
          v-model="suggestionSearchTerm"
          autocomplete="off"
        />
        <i class="search icon"></i>
      </div>
    </div>
    <div class="header item">{{ $tc('ACTION', 2) }}</div>
    <div class="scroller">
      <div class="item" v-for="(s, index) in filteredSuggestions" :key="index">
        <div
          class="ui horizontal small label"
          v-if="s.type"
          :class="{
            yellow: s.type === 'dialog',
            teal: s.type === 'wait',
            purple: s.type === 'flow',
            green: s.type === 'excel'
          }"
        >
          {{ s.type }}
        </div>
        <div style="margin-bottom: 8px;">
          <a href="#" @click.prevent="handleInsert(s.text)">{{ s.display }}</a>
        </div>
        <div v-if="s.actions && s.actions.length > 0">
          <a
            class="ui tiny basic label"
            style="margin-right: 2px; margin-top: 4px;"
            v-for="(a, index) in s.actions"
            :key="index"
            @click.prevent="handleInsert(a.text)"
          >
            {{ a.display }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @flow
import _ from 'lodash'
export default {
  name: 'shortcut-menu',
  props: ['suggestions', 'handleInsert'],
  computed: {
    filteredSuggestions() {
      return _.filter(this.suggestions, s => {
        return (
          s.display &&
          s.display.toLowerCase().indexOf(this.suggestionSearchTerm.toLowerCase()) !== -1 &&
          s.text &&
          s.text.toLowerCase().indexOf(this.suggestionSearchTerm.toLowerCase()) !== -1
        )
      })
    }
  },
  data() {
    return {
      suggestionSearchTerm: ''
    }
  }
}
</script>
